// User-facing Italian labels for the Salute wizard fields that can block
// "Continua". Mirrors src/screens/PubblicoImpiegoProduct/PubblicoImpiegoFormFlow.stepErrors.js.
export const STEP_FIELD_LABELS = {
  // Step 1 — Dati Personali
  gender: 'Il contraente è',
  name: 'Nome',
  surname: 'Cognome',
  date_of_birth: 'Data di nascita',
  commune_of_birth_code: 'Comune di nascita',
  province_of_birth_code: 'Provincia di nascita',
  born_abroad: "Nato all'estero",
  country_of_birth_code: 'Stato estero di nascita',
  residence_commune_code: 'Comune di residenza',
  residence_province_code: 'Provincia di residenza',
  postal_code: 'CAP',
  address: 'Indirizzo',
  house_number: 'Numero civico',
  email: 'Email',
  phone: 'Telefono',
  work_type: 'Tipo di lavoro',
  policy_effective_date: 'Data di decorrenza polizza',

  // Step 2 — Questionario Sanitario
  suffer_from_diseases: 'Dichiarazione malattie',
  cronic_diseases: 'Malattie croniche',
  permanent_consequences: 'Conseguenze permanenti',
  presence_required: 'Obbligo di segnalazione presenza',
};

export const getBlockingFields = (errors, stepFields) => (stepFields || []).filter((field) => errors && errors[field]);

// Keep the list short enough to stay readable inside a toast.
export const buildMissingFieldsMessage = (fields, labels = STEP_FIELD_LABELS, max = 3) => {
  const names = (fields || []).map((field) => labels[field] || field);
  if (names.length > max) {
    return `Compila i campi obbligatori: ${names.slice(0, max).join(', ')} e altri ${names.length - max}.`;
  }
  return `Compila i campi obbligatori: ${names.join(', ')}.`;
};
